import axios from '../../utils/axios';

export default function fetchLGBillTargets(adminId, params = {}) {
    return (
        axios.get(`/admin/${adminId}/allLGBillTargets`,  {params} )
    )
}
